module.exports = __webpack_public_path__ + "step4_female_to_male.08a63557.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step4_female_to_male.jpg
// module id = Rebw
// module chunks = 0